<template>
  <div class="gs-wrap">
    <div class="gs-scope-wrap">
      <global-dropdown
        id="global-search-scope"
        :value="assetType"
        :options="scopeOptions"
        :size="32"
        :min-width="125"
        panel-class="gs-scope-panel"
        full-width
        @input="selectScope"
      />
    </div>

    <div class="gs-search-box">
      <input
        ref="searchInput"
        v-model="assetName"
        placeholder="Search for asset(s) by name"
        @keydown="nameKeydown($event)"
        @keydown.enter="performSearch"
      />
      <svg
        width="13"
        height="13"
        viewBox="0 0 16 16"
        class="gs-search-icon"
        role="button"
        aria-label="Search"
        tabindex="0"
        @click="
          assetName && assetName.length >= 1
            ? performSearch()
            : $refs.searchInput.focus()
        "
        @keydown.enter="
          assetName && assetName.length >= 1
            ? performSearch()
            : $refs.searchInput.focus()
        "
      >
        <path
          d="M6.5 1a5.5 5.5 0 104.22 9.03l3.12 3.12.71-.71L11.44 9.2A5.5 5.5 0 006.5 1zm0 1a4.5 4.5 0 110 9 4.5 4.5 0 010-9z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { getAssetTypesExcludingItems } from '../static/AssetTypes.js';
import GlobalDropdown from './GlobalDropdown.vue';

export default {
  name: 'GlobalSearchControl',
  components: {
    GlobalDropdown,
  },
  data() {
    return {
      assetsTypes: getAssetTypesExcludingItems([]),
      assetType: 'All',
      assetName: '',
    };
  },
  computed: {
    scopeOptions() {
      return this.assetsTypes.map((item) => ({
        id: item.name,
        value: item.name,
        label: item.name,
      }));
    },
  },
  watch: {
    assetName(val) {
      if (!val) return;
      this.assetName = val.replace(/%/g, '');
    },
  },
  created() {
    const routeParams = window.location.hash.split('/');
    if (routeParams[1] === 'Global-Search') {
      this.assetType = this.decodeRouteParam(routeParams[2]) || this.assetType;
      this.assetName = this.decodeRouteParam(routeParams[3]) || this.assetName;
    }
    if (this.$route.params.assettype !== undefined) {
      this.assetType = this.decodeRouteParam(this.$route.params.assettype);
    }
    if (this.$route.params.assetname !== undefined) {
      this.assetName = this.decodeRouteParam(this.$route.params.assetname);
    }
  },
  mounted() {
    let sortedAssetTypes = [...this.assetsTypes];
    sortedAssetTypes.push({
      name: 'Identities',
      entityId: 0,
      detailsPageLink: '',
      reviewSteps: '',
    });
    sortedAssetTypes = sortedAssetTypes.sort((a, b) =>
      a.name.localeCompare(b.name)
    );
    sortedAssetTypes.unshift({
      name: 'All',
      entityId: 0,
      detailsPageLink: '',
      reviewSteps: '',
    });
    this.assetsTypes = sortedAssetTypes;

    if (!this.assetsTypes.some((item) => item.name === this.assetType)) {
      this.assetType = 'All';
    }
  },
  methods: {
    decodeRouteParam(value) {
      if (value == null) return value;
      try {
        return decodeURIComponent(value);
      } catch (_err) {
        return value;
      }
    },
    selectScope(name) {
      this.assetType = name;
      this.$emit('assetselected', name);
    },
    nameKeydown(e) {
      if (e.key.includes('%')) {
        e.preventDefault();
      }
    },
    performSearch() {
      if (this.assetName != undefined && this.assetName.length >= 1) {
        window.location =
          this.SbBaseUrl +
          '/Home#/Global-Search/' +
          encodeURIComponent(this.assetType) +
          '/' +
          encodeURIComponent(this.assetName);
      }
    },
  },
};
</script>

<style scoped>
.gs-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}

.gs-scope-wrap {
  flex-shrink: 0;
  min-width: 125px;
  width: max-content;
}

.gs-scope-wrap >>> .gs-scope-panel {
  max-height: none;
  overflow-y: visible;
}

.gs-search-box {
  display: flex;
  align-items: center;
  gap: 4px;
  background: var(--surface2, #f8fafc);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 8px;
  padding: 0 12px 0 12px;
  height: 32px;
  width: 240px;
}

.gs-search-icon {
  flex-shrink: 0;
  fill: var(--text3, #94a3b8);
  cursor: pointer;
}

.gs-search-icon:hover {
  fill: var(--text, #1e293b);
}

.gs-search-box input {
  background: none;
  border: none;
  outline: none;
  color: var(--text, #1e293b);
  font-size: 13px;
  width: 100%;
  font-family: inherit;
}

.gs-search-box input::placeholder {
  color: var(--text3, #94a3b8);
}

html.dark .gs-search-box {
  background: var(--border, #374151);
  border-color: var(--border2, #4b5563);
}

html.dark .gs-search-icon {
  fill: var(--text3, #6b7280);
}

html.dark .gs-search-icon:hover {
  fill: var(--text, #e5e7eb);
}

html.dark .gs-search-box input {
  color: var(--text, #e5e7eb);
}

html.dark .gs-search-box input::placeholder {
  color: var(--text3, #6b7280);
}

@media (prefers-color-scheme: dark) {
  html:not(.light):not(.dark) .gs-search-box {
    background: var(--border, #374151);
    border-color: var(--border2, #4b5563);
  }

  html:not(.light):not(.dark) .gs-search-icon {
    fill: var(--text3, #6b7280);
  }

  html:not(.light):not(.dark) .gs-search-icon:hover {
    fill: var(--text, #e5e7eb);
  }

  html:not(.light):not(.dark) .gs-search-box input {
    color: var(--text, #e5e7eb);
  }

  html:not(.light):not(.dark) .gs-search-box input::placeholder {
    color: var(--text3, #6b7280);
  }
}
</style>
